import styled from "styled-components";

interface LoadingProps {
  url: string;
}

export interface LoadingAreaProps{
  height?: string;
}



export const LoadingArea = styled.div<LoadingAreaProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${(props) => props.height || '100vh'};

  h1 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 31px;
    color: var(--primary);
  }
`;

export const LoadingPhrase = styled.p`
  margin: 16px auto 0;
  padding: 0 16px;
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 90%;
  color: #5768ff;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 31px;
  text-align: center;
  animation: lp-fade-in 0.5s ease-out both;
  will-change: opacity, transform;

  @keyframes lp-fade-in {
    from {
      opacity: 0;
      transform: translateY(6px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const LoadingImage = styled.div<LoadingProps>`
  display: inline-block;
  position: relative;
  width: 100px;
  height: 100px;

  div {
    background: url(${(props) => props.url});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    animation: lds-heart 1.2s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  div:after,
  div:before {
    content: " ";
    position: absolute;
    display: block;
    width: 100px;
    height: 100px;
    background: url(${(props) => props.url});
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
  }

  @keyframes lds-heart {
    0% {
      transform: scale(0.95);
    }
    5% {
      transform: scale(1.1);
    }
    39% {
      transform: scale(0.85);
    }
    45% {
      transform: scale(1);
    }
    60% {
      transform: scale(0.95);
    }
    100% {
      transform: scale(0.9);
    }
  }
`;